import React from "react";

import "../../css/ReviewSummaryPanel.css";
interface Props {
  reportName: string;
  summary: string;
  onSummaryChange: (value: string) => void;
  onSubmit: () => void;
}

const ReviewSummaryPanel: React.FC<Props> = ({
  reportName,
  summary,
  onSummaryChange,
  onSubmit,
}) => {
  return (
    <div className="review-summary-panel">

      <h2>Clinical Review</h2>

      <div className="report-title">

        Current Report

        <span>{reportName}</span>

      </div>

      <label>Summary</label>

      <textarea
        value={summary}
        maxLength={1000}
        onChange={(e) =>
          onSummaryChange(e.target.value)
        }
        placeholder="Write report summary..."
      />

      <div className="character-count">
        {summary.length}/1000 Characters
      </div>

      <button
        onClick={onSubmit}
      >
        Submit Summary
      </button>

    </div>
  );
};

export default ReviewSummaryPanel;